var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "账号信息", width: 60 },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "userCustomerManagerForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.userCustomerManagerForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 18 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "登录帐号", prop: "userName" } },
                    [
                      _c("Input", {
                        attrs: {
                          readonly:
                            _vm.formEditMode === _vm.FORM_EDIT_MODE_MODIFY,
                        },
                        model: {
                          value: _vm.userCustomerManagerForm.userName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userCustomerManagerForm,
                              "userName",
                              $$v
                            )
                          },
                          expression: "userCustomerManagerForm.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: { label: "姓名", prop: "userCustomerManagerName" },
                    },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userCustomerManagerForm.userCustomerManagerName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userCustomerManagerForm,
                              "userCustomerManagerName",
                              $$v
                            )
                          },
                          expression:
                            "\n                            userCustomerManagerForm.userCustomerManagerName\n                        ",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "所属区域",
                        prop: "userCustomerManagerAreaUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userCustomerManagerForm
                                .userCustomerManagerAreaUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userCustomerManagerForm,
                                "userCustomerManagerAreaUuid",
                                $$v
                              )
                            },
                            expression:
                              "\n                            userCustomerManagerForm.userCustomerManagerAreaUuid\n                        ",
                          },
                        },
                        _vm._l(_vm.areaSource, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.areaUuid,
                              attrs: { value: item.areaUuid },
                            },
                            [_vm._v(_vm._s(item.areaName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "手机",
                        prop: "userCustomerManagerPhone",
                      },
                    },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userCustomerManagerForm
                              .userCustomerManagerPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userCustomerManagerForm,
                              "userCustomerManagerPhone",
                              $$v
                            )
                          },
                          expression:
                            "\n                            userCustomerManagerForm.userCustomerManagerPhone\n                        ",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 18 } },
            [
              _vm.formEditMode === _vm.FORM_EDIT_MODE_MODIFY
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "编号",
                            prop: "userCustomerManagerCode",
                          },
                        },
                        [
                          _c("Input", {
                            model: {
                              value:
                                _vm.userCustomerManagerForm
                                  .userCustomerManagerCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.userCustomerManagerForm,
                                  "userCustomerManagerCode",
                                  $$v
                                )
                              },
                              expression:
                                "\n                            userCustomerManagerForm.userCustomerManagerCode\n                        ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "审批",
                        prop: "userCustomerManagerApproval",
                      },
                    },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value:
                              _vm.userCustomerManagerForm
                                .userCustomerManagerApproval,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userCustomerManagerForm,
                                "userCustomerManagerApproval",
                                $$v
                              )
                            },
                            expression:
                              "\n                            userCustomerManagerForm.userCustomerManagerApproval\n                        ",
                          },
                        },
                        _vm._l(_vm.approvalSource, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [
                              _vm._v(
                                _vm._s(item.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "免试资格",
                        prop: "userCustomerManagerPassAll",
                      },
                    },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value:
                              _vm.userCustomerManagerForm
                                .userCustomerManagerPassAll,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userCustomerManagerForm,
                                "userCustomerManagerPassAll",
                                $$v
                              )
                            },
                            expression:
                              "\n                            userCustomerManagerForm.userCustomerManagerPassAll\n                        ",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                          _c("Radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "微信二维码",
                        prop: "userCustomerManagerWechatFile",
                      },
                    },
                    [
                      _c("single-file-upload-with-name", {
                        attrs: { imgHeight: 150, imgWidth: 150 },
                        model: {
                          value:
                            _vm.userCustomerManagerForm
                              .userCustomerManagerWechatFile,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userCustomerManagerForm,
                              "userCustomerManagerWechatFile",
                              $$v
                            )
                          },
                          expression:
                            "\n                            userCustomerManagerForm.userCustomerManagerWechatFile\n                        ",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 18 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "部门", prop: "department" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value: _vm.userCustomerManagerForm.departmentUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userCustomerManagerForm,
                                "departmentUuid",
                                $$v
                              )
                            },
                            expression:
                              "userCustomerManagerForm.departmentUuid",
                          },
                        },
                        _vm._l(_vm.departmentList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.departmentUuid,
                              attrs: { value: item.departmentUuid },
                            },
                            [
                              _vm._v(
                                _vm._s(item.departmentName) +
                                  "-" +
                                  _vm._s(item.departmentContact)
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "是否是市场部", prop: "mktType" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value: _vm.userCustomerManagerForm.mktType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userCustomerManagerForm,
                                "mktType",
                                $$v
                              )
                            },
                            expression: "userCustomerManagerForm.mktType",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "false" } }, [
                            _vm._v("否"),
                          ]),
                          _c("Radio", { attrs: { label: "true" } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "默认苗场(代下单)",
                        prop: "defaultSeedFarmUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value:
                              _vm.userCustomerManagerForm.defaultSeedFarmUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userCustomerManagerForm,
                                "defaultSeedFarmUuid",
                                $$v
                              )
                            },
                            expression:
                              "userCustomerManagerForm.defaultSeedFarmUuid",
                          },
                        },
                        _vm._l(_vm.seedFarmOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.seedFarmUuid,
                              attrs: { value: item.seedFarmUuid },
                            },
                            [
                              _vm._v(
                                _vm._s(item.seedFarmCode) +
                                  "-" +
                                  _vm._s(item.seedFarmName)
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 18 } },
            [
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码" } },
                        [
                          _c("Input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.password,
                              callback: function ($$v) {
                                _vm.password = $$v
                              },
                              expression: "password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码确认" } },
                        [
                          _c("Input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.passwordConfirm,
                              callback: function ($$v) {
                                _vm.passwordConfirm = $$v
                              },
                              expression: "passwordConfirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$checkAccessArray(["S"]) && _vm.serviceAreaFormShow
        ? _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c("Divider", { attrs: { orientation: "left", size: "small" } }, [
                _vm._v("服务区域"),
              ]),
              _c(
                "Form",
                { attrs: { model: _vm.serviceAreaForm } },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "6" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "服务区域等级",
                                prop: "regionGrade",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  on: { "on-change": _vm.onRegionGradeChange },
                                  model: {
                                    value: _vm.serviceAreaForm.regionGrade,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.serviceAreaForm,
                                        "regionGrade",
                                        $$v
                                      )
                                    },
                                    expression: "serviceAreaForm.regionGrade",
                                  },
                                },
                                _vm._l(_vm.regionGradeList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.val,
                                      attrs: { value: item.val },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 18 } },
                    [
                      _vm.serviceAreaForm.regionGrade == 1
                        ? _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "provinceUuids" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        multiple: "",
                                        clearable: "",
                                        placeholder: "请选择省",
                                      },
                                      model: {
                                        value:
                                          _vm.serviceAreaForm.provinceUuids,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.serviceAreaForm,
                                            "provinceUuids",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "serviceAreaForm.provinceUuids",
                                      },
                                    },
                                    _vm._l(
                                      _vm.provinceOptions,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.regionUuid,
                                            attrs: { value: item.regionUuid },
                                          },
                                          [_vm._v(_vm._s(item.regionName))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.serviceAreaForm.regionGrade == 2 ||
                      _vm.serviceAreaForm.regionGrade == 3
                        ? _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "provinceUuid" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择省",
                                      },
                                      on: { "on-change": _vm.onProvinceChange },
                                      model: {
                                        value: _vm.serviceAreaForm.provinceUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.serviceAreaForm,
                                            "provinceUuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "serviceAreaForm.provinceUuid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.provinceOptions,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.regionUuid,
                                            attrs: { value: item.regionUuid },
                                          },
                                          [_vm._v(_vm._s(item.regionName))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.serviceAreaForm.regionGrade == 2
                        ? _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "cityUuids" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        multiple: "",
                                        clearable: "",
                                        placeholder: "请选择市",
                                      },
                                      model: {
                                        value: _vm.serviceAreaForm.cityUuids,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.serviceAreaForm,
                                            "cityUuids",
                                            $$v
                                          )
                                        },
                                        expression: "serviceAreaForm.cityUuids",
                                      },
                                    },
                                    _vm._l(_vm.cityOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.serviceAreaForm.regionGrade == 3
                        ? _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "cityUuid" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择市",
                                      },
                                      on: { "on-change": _vm.onCityChange },
                                      model: {
                                        value: _vm.serviceAreaForm.cityUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.serviceAreaForm,
                                            "cityUuid",
                                            $$v
                                          )
                                        },
                                        expression: "serviceAreaForm.cityUuid",
                                      },
                                    },
                                    _vm._l(_vm.cityOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.serviceAreaForm.regionGrade == 3
                        ? _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "regionUuids" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        multiple: "",
                                        clearable: "",
                                        placeholder: "请选择区/县",
                                      },
                                      model: {
                                        value: _vm.serviceAreaForm.regionUuids,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.serviceAreaForm,
                                            "regionUuids",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "serviceAreaForm.regionUuids",
                                      },
                                    },
                                    _vm._l(_vm.distOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "Col",
                        { attrs: { span: "6" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addServiceArea },
                                },
                                [_vm._v("添加")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "服务区域列表" } },
                            [
                              _c("Table", {
                                ref: "regionTable",
                                attrs: {
                                  size: "small",
                                  columns: _vm.regionTable.columns,
                                  data: _vm.serviceAreaList,
                                  stripe: "",
                                  border: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _vm.$checkAccessArray(["S", "G"])
            ? _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [_vm._v("确认")]
              )
            : _vm._e(),
          _c(
            "Button",
            {
              attrs: { type: "error" },
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }